/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./calendar-comp.component";
var styles_CalendarCompComponent = [];
var RenderType_CalendarCompComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_CalendarCompComponent, data: {} });
export { RenderType_CalendarCompComponent as RenderType_CalendarCompComponent };
export function View_CalendarCompComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [], null, null, null, null, null))], null, null); }
export function View_CalendarCompComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-calendarcomp", [], null, null, null, View_CalendarCompComponent_0, RenderType_CalendarCompComponent)), i0.ɵdid(1, 4308992, null, 0, i1.CalendarCompComponent, [i0.ElementRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CalendarCompComponentNgFactory = i0.ɵccf("app-calendarcomp", i1.CalendarCompComponent, View_CalendarCompComponent_Host_0, { options: "options" }, {}, []);
export { CalendarCompComponentNgFactory as CalendarCompComponentNgFactory };
